export enum PricingRegion {
  China = 'china',
  RestOfWorld = 'row',
}
